import ErrorCode from 'v2/core/errors/codes';

export const AUTH_ERROR_CODE_MESSAGE = {
  [ErrorCode.UserUnapproved]:
    'It appears that you have not been invited yet. Please reach out to your organization admins to get an invite.',
  [ErrorCode.UserSuspended]:
    'Your account has been suspended. Please reach out to your organization admins for more details.',
  [ErrorCode.InvalidSsoIdpToken]:
    'Your organization has enforced SSO. Please sign in with SSO.',
  [ErrorCode.TrialExpired]:
    'Your trial period has ended. Please contact the Enterpret team.',
};
